<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UBQb32/tc-custom/9781426814488.jpg?1703681133946" alt="This image is the cover for the book Banker's Convenient Wife, Brides of L'Amour"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Banker's Convenient Wife, Brides of L'Amour
      </h1>
      <p class="bookDescription body article font2">
        <b>Amnesia complicates a playboy billionaire’s marriage of convenience in this classic contemporary romance by a <i>USA Today</i>–bestselling author.</b><br/><br/>Italian-Swiss banker Roel Sabatino has suffered partial memory loss after a car crash. It seems he has a wife . . . but he can’t remember getting married!<br/><br/>Hilary is pretty, sweet . . . and ordinary. When Roel tries to take her to bed—as any husband would—he discovers she’s a virgin! All this is shocking to Roel, though he still recognizes a great deal when he sees one. So why not enjoy all the pleasures that this marriage has to offer, whatever his reasons were for tying the knot?<br/><br/><i>Originally published in 2004</i>.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lynne Graham
      </h2>
      
      <p class="authorDescription body article">Lynne Graham lives in Northern Ireland and has been a keen romance reader since her teens. Happily married, Lynne has five children. Her eldest is her only natural child. Her other children, who are every bit as dear to her heart, are adopted. The family has a variety of pets, and Lynne loves gardening, cooking, collecting allsorts and is crazy about every aspect of Christmas.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?50be68c9